import { render, staticRenderFns } from "./LoggedinPerson.vue?vue&type=template&id=fb42a866&scoped=true"
import script from "./LoggedinPerson.vue?vue&type=script&lang=js"
export * from "./LoggedinPerson.vue?vue&type=script&lang=js"
import style0 from "./LoggedinPerson.vue?vue&type=style&index=0&id=fb42a866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb42a866",
  null
  
)

export default component.exports